import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';

import {
  typeOfAdherenceClubAnswers, peopleReachedAnswers, frequencyOfMeetingsAnswers
} from '../../constants/funding-request-answers/adherence-clubs-question-answers.const';

import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';
import {FormValidationService} from '../../../../../../../services/form-validation/form-validation.service';
import {checkForValue} from '../../../../../../organisation/capacity-spectrum/components/capacity-spectrum/store/capacity-spectrum.model';

@Component({
  selector: 'app-adherence-clubs',
  templateUrl: './adherence-clubs.component.html',
  styleUrls: ['./adherence-clubs.component.scss']
})
export class AdherenceClubsComponent implements OnInit {


  @Input() adherenceClubsForm: FormGroup;
  @Input() formValid: boolean;
  @Input() isReadOnly: boolean;
  @Input() fromReview: boolean;

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  typeOfAdherenceClubOptions = typeOfAdherenceClubAnswers;
  peopleReachedOptions = peopleReachedAnswers;
  frequencyOfMeetingsOptions = frequencyOfMeetingsAnswers;
  numberMask: any;

  durationOfTypeOptions = [
    {
      label: 'Days',
      value: 'Days'
    },
    {
      label: 'Months',
      value: 'Months'
    }
  ];

  constructor(public formValidationService: FormValidationService) {
  }

  ngOnInit() {
    this.numberMask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: false,
      allowNegative: false,
      includeThousandsSeparator: false
    });
  }

  checkOther(value: string | boolean, selectedValue: string, controlParent: AbstractControl, controlChild: AbstractControl) {
    checkForValue(value, selectedValue, controlParent, controlChild);
  }
}
